<template>
  <div v-if="histories">
    <b-list-group :key="history.model.gli" v-for="history in histories" class="mb-2">
      <b-list-group-item variant="info">
        {{ history.model.gli }} - {{ history.model.description }}
      </b-list-group-item>
      <b-list-group-item @click="associate(file)" button :key="file.id" v-for="file in history.files">
       <font-awesome-icon icon="fa-solid fa-plus" class="mr-2"/> {{ file.orig_filename }}
      </b-list-group-item>
    </b-list-group>
  </div>
</template>

<script>
export default {
  name: "files-history",
  data() {
    return {
      histories: null
    }
  },
  props: {
    url: String,
  },
  mounted() {
    this.refresh()
  },
  methods: {
    async refresh() {
      this.histories = await this.asyncAction(this.url, 'GET')
    },
    async associate(file) {
      await this.asyncAction(file._links.associate_url.href, file._links.associate_url.method)
      await this.refresh()
    }
  }
}
</script>

<style scoped>

</style>